import sliceCreator from '../../index.jsx';
import {GET_ALL_ACTIVITIES} from '../../../constants/index.jsx';
const _getAllActivitiesAction = sliceCreator('GET_ALL_ACTIVITIES', GET_ALL_ACTIVITIES, 'get');

const { asyncAction: getAllActivitiesAction, reducer, clearData: clearGetAllActivitiesAction } = _getAllActivitiesAction;

export default reducer;

export {
    getAllActivitiesAction,
    clearGetAllActivitiesAction
}